import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { Footer } from "../../../components/FooterV2";
import { SolutionIndustryCustomer } from "../../../blocks/solution-industry-customer";
import { SolutionIndustrySupport } from "../../../blocks/solution-industry-support";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { useTranslation } from "react-i18next";
import { SolutionSceneValue } from "../../../blocks/solution-scene-value";
import { SolutionIndustryBanner } from "../../../blocks/solution-industry-banner";
import { SolutionSceneIntro } from "../../../blocks/solution-scene-intro";
import { SolutionSceneScreen } from "../../../blocks/solution-scene-screen";
import { Helmet } from "react-helmet";
import { Notice } from "../../../components/Notice";

export const IdaasPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const select_list = [
    {
      subLabel: t("solution.idaas.type.item1.title"),
      content: t("solution.idaas.type.item1.descript"),
      imgUrl: "//files.authing.co/authing-website/solution-idaas-operation.png",
      docLink: "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-pc/",
      alt: "身份云IDaaS已替代传统IAM",
    },
    {
      subLabel: t("solution.idaas.type.item2.title"),
      content: t("solution.idaas.type.item2.descript"),
      imgUrl: "//files.authing.co/authing-website/solution-idaas-expand.png",
      docLink:
        "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram-qrcode/",
      alt: "IDaaS替代IAM",
    },
    {
      subLabel: t("solution.idaas.type.item3.title"),
      content: t("solution.idaas.type.item3.descript"),
      imgUrl: "//files.authing.co/authing-website/solution-idaas-security.png",
      docLink:
        "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-mobile.html",
      alt: "身份云替代IAM",
    },
  ];
  return (
    <div className="idaas-page">
      <Helmet>
        <title>
          身份云 IDaaS 替代 IAM- Authing 身份云-统一身份认证-Authing 身份云
        </title>
      </Helmet>
      <Header mode="light" hasNotice />
      <SolutionIndustryBanner
        title={t("solution.idaas.banner.title")}
        subtitle={t("solution.idaas.banner.subtitle")}
        imgUrl="//files.authing.co/authing-website/solution-banner-idaas-v2.png"
        tagFrom="idaas"
      />
      {/* <SolutionIndustryCustomer /> */}
      <SolutionSceneIntro scene={t("solution.idaas.intro")} />
      <SolutionSceneValue value={t("solution.idaas.value")} />
      <SolutionSceneScreen list={select_list} />
      <SolutionIndustrySupport
        supportTitle={t("solution.scene.title-support")}
        noLastBlock
      />
      <CommonPageLink pagesLink={pagesLink} />

      <HomeTryOn hasBg />

      <Footer />
    </div>
  );
};
